import type {RatesMap, SupportedAssets} from '@/types';

/**
 * Flattens a `RatesMap` into the square matrix `handleArbitrageCheck` consumes.
 *
 * `RatesValueMap` leaves are wire strings (`AfriexRate.value: string`), so the
 * conversion to `number` is explicit here rather than left to the arithmetic in
 * `detectArbitrage` (same treatment as `RatesTable` and `RateWidget`).
 */
export const transformRatesMapToMatrix = (ratesMap: RatesMap): number[][] => {
  const fromSymbols = Object.keys(ratesMap) as SupportedAssets[];
  const size = fromSymbols.length;
  const ratesMatrix: number[][] = new Array<number[]>(size)
    .fill([])
    .map(() => new Array<number>(size).fill(0));
  for (let i = 0; i < size; i += 1) {
    const row = ratesMap[fromSymbols[i]] ?? {};
    const toSymbols = Object.keys(row) as SupportedAssets[];
    for (let j = 0; j < toSymbols.length; j += 1) {
      ratesMatrix[i][j] = Number(row[toSymbols[j]]);
    }
  }
  return ratesMatrix;
};
